<template>
  <div style="padding: 15px" v-if="lang">
    <md-layout md-gutter class="register-doctor main--content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div
          v-if="doctor.plan_status == 2"
          style="
            height: 110px !important;
            background: #ffeb3b;
            color: black;
            padding: 20px;
            border-radius: 5px;
            margin-bottom: 10px;
            text-align: justify;
          "
          class="alert alert-success"
        >
          Usted adeuda {{ doctor.plan_owed }}
          {{ doctor.user.plan.period_months == 12 ? "año(s)" : "mes(es)" }}.
          <br /><md-button @click.native="renewPlan()" class="md-raised"
            >Pagar ahora</md-button
          >
        </div>
        <div
          v-if="doctor.plan_status == 1"
          style="
            height: auto !important;
            background: rgb(180, 219, 134);
            color: black;
            padding: 20px;
            border-radius: 5px;
            margin-bottom: 10px;
            text-align: justify;
          "
          class="alert alert-success"
        >
          Usted esta al dia en sus pagos.
          <br />
          <!-- <md-button v-if="doctor.code='25587453-5'" @click.native="anualPlan()" class="md-raised">Pasar a Plan Anual</md-button> -->
        </div>
      </div>
      <div class="col-md-2 col-sm-12 col-xs-12 no-padder">
        <div class="profile-image">
          <img :src="profile_image" class="img-responsive img-rounded" />
          <div @click="uploadAvatarIcon" class="camera_upload">
            <md-icon>photo_camera</md-icon>
          </div>
        </div>
        <span
          class="md-error"
          style="
            width: 100%;
            display: block;
            text-align: center;
            margin-top: 20px;
            color: red;
          "
          >{{
            errors.hasOwnProperty("formAvatar") && errors.formAvatar.length > 3
              ? errors.formAvatar
              : ""
          }}</span
        >
        <form
          id="formAvatar"
          style="display: none"
          method="POST"
          enctype="multipart/form-data"
        >
          <input
            id="fileAvatar"
            type="file"
            name="avatar"
            @change="onAvatarChange"
          />
          <button type="submit">
            {{ translate.pages.profile_doctor["avatar-btn"] }}
          </button>
        </form>
      </div>
      <div class="col-md-10 col-sm-12 col-xs-12 no-padder" v-if="doctor.user">
        <form novalidate @submit.stop.prevent="submit">
          <div style="padding: 0">
            <div class="col-md-6">
              <md-input-container
                :class="{ 'md-input-invalid': errors.hasOwnProperty('code') }"
              >
                <label>{{ translate.pages.profile_doctor.fields.code }}</label>
                <md-input v-model="doctor.code" disabled></md-input>
                <span class="md-error">{{
                  errors.hasOwnProperty("code") ? errors.code[0] : ""
                }}</span>
              </md-input-container>
            </div>
            <div class="col-md-6">
              <md-input-container
                :class="{ 'md-input-invalid': errors.hasOwnProperty('name') }"
              >
                <label>{{ translate.pages.profile_doctor.fields.name }}</label>
                <md-input v-model="doctor.name" required></md-input>
                <span class="md-error">{{
                  errors.hasOwnProperty("name") ? errors.name[0] : ""
                }}</span>
              </md-input-container>
            </div>
            <div class="col-md-6" v-if="doctor.is_institution !== 1">
              <md-input-container
                :class="{
                  'md-input-invalid': errors.hasOwnProperty('lastname'),
                }"
              >
                <label>{{
                  translate.pages.profile_doctor.fields.lastname
                }}</label>
                <md-input v-model="doctor.lastname"></md-input>
                <span class="md-error">{{
                  errors.hasOwnProperty("lastname") ? errors.lastname[0] : ""
                }}</span>
              </md-input-container>
            </div>
            <div class="col-md-6" v-if="doctor.is_institution !== 1">
              <md-input-container
                :class="{
                  'md-input-invalid': errors.hasOwnProperty('lastname2'),
                }"
              >
                <label>{{
                  translate.pages.profile_doctor.fields.lastname2
                }}</label>
                <md-input v-model="doctor.lastname2"></md-input>
                <span class="md-error">{{
                  errors.hasOwnProperty("lastname2") ? errors.lastname2[0] : ""
                }}</span>
              </md-input-container>
            </div>
            <div class="col-md-6">
              <md-input-container
                :class="{ 'md-input-invalid': errors.hasOwnProperty('email') }"
              >
                <label>{{ translate.pages.profile_doctor.fields.email }}</label>
                <md-input v-model="doctor.email" disabled></md-input>
                <span class="md-error">{{
                  errors.hasOwnProperty("email") ? errors.email[0] : ""
                }}</span>
              </md-input-container>
            </div>
            <div class="col-md-6">
              <md-input-container
                :class="{ 'md-input-invalid': errors.hasOwnProperty('phone') }"
              >
                <label>{{ translate.pages.profile_doctor.fields.phone }}</label>
                <md-input
                  v-model="doctor.phone"
                  v-validate
                  data-vv-rules="required|numeric|min:6|max:12"
                  data-vv-name="doctor.phone"
                  required
                ></md-input>
                <div class="marcaagua">ej: 912345</div>
                <span class="md-error">{{
                  errors.hasOwnProperty("phone") ? errors.phone[0] : ""
                }}</span>
              </md-input-container>
            </div>
            <div style="background: #fafafa">
              <div
                class="col-md-6"
                style="background: #fafafa"
                v-if="doctor.is_institution == 1"
              >
                <label style="color: #959ea6 !important; font-size: 12px"
                  >Provincia <span style="color: #f26061">*</span></label
                >
                <vue-select
                  :options="regions"
                  placeholder="Provincia"
                  :on-change="changeRegion"
                  v-model="doctor.region.label"
                  style=""
                  required
                >
                  <span slot="no-options">No se encontraron resultados.</span>
                </vue-select>

                <span class="md-error">{{
                  errors.hasOwnProperty("region_id") ? errors.region_id : ""
                }}</span>
              </div>
              <div
                class="col-md-6"
                style="background: #fafafa"
                v-if="doctor.is_institution == 1"
              >
                <label style="color: #959ea6 !important; font-size: 12px"
                  >Comuna <span style="color: #f26061">*</span></label
                >
                <vue-select
                  :options="cities"
                  placeholder="Comuna"
                  :on-change="changeCity"
                  v-model="doctor.city.label"
                  required
                >
                  <span slot="no-options">No se encontraron resultados.</span>
                </vue-select>
                <span class="md-error">{{
                  errors.hasOwnProperty("comunity") ? errors.comunity : ""
                }}</span>
              </div>
              <div
                class="col-md-6"
                style="background: #fafafa"
                v-if="doctor.is_institution == 1"
              >
                <md-input-container
                  :class="{
                    'md-input-invalid': errors.hasOwnProperty('street'),
                  }"
                >
                  <label>{{
                    translate.pages.profile_doctor.fields.street
                  }}</label>
                  <md-input v-model="doctor.street"></md-input>
                  <span class="md-error">{{
                    errors.hasOwnProperty("street") ? errors.street : ""
                  }}</span>
                </md-input-container>
              </div>
              <div
                class="col-md-6"
                style="background: #fafafa"
                v-if="doctor.is_institution == 1"
              >
                <md-input-container
                  :class="{
                    'md-input-invalid': errors.hasOwnProperty('number'),
                  }"
                >
                  <label>{{
                    translate.pages.profile_doctor.fields.number
                  }}</label>
                  <md-input v-model="doctor.number"></md-input>
                  <span class="md-error">{{
                    errors.hasOwnProperty("number") ? errors.number[0] : ""
                  }}</span>
                </md-input-container>
              </div>
            </div>
            <div class="spacer"></div>
            <div class="profile--check">
              <div class="col-md-6 mar-top-1">
                <md-input-container style="margin: 0 !important">
                  <md-input
                    type="text"
                    autocomplete="off"
                    v-model="filterSpecialities"
                    placeholder="Buscar Especialidad..."
                  ></md-input>
                </md-input-container>
                <div class="multiple checkbox-list">
                  <p class="title">
                    {{ translate.pages.profile_doctor.fields.specialities }}
                  </p>
                  <div class="select">
                    <md-checkbox
                      class="option md-primary text--color"
                      v-for="speciality in filteredSpecialities"
                      :key="speciality.id"
                      @change="onChosen($event, speciality.id)"
                      v-model="speciality.checked"
                      >{{ speciality.name }}</md-checkbox
                    >
                  </div>
                </div>
                <label
                  class="subtitle"
                  :class="{ error: errors.specialities.invalid }"
                  >{{
                    translate.pages.profile_doctor.fields.select_specialties
                  }}</label
                >
              </div>
              <div class="col-md-6 checkbox-list checkbox-options">
                <div>
                  <md-checkbox
                    id="notification_appointment"
                    md-theme="green"
                    class="md-primary text--color"
                    name="notification_appointment"
                    v-model="doctor.notification_appointment"
                    >{{
                      translate.pages.profile_doctor.fields
                        .notification_appointment
                    }}</md-checkbox
                  >
                </div>
                <div>
                  <md-checkbox
                    id="notification_mail"
                    md-theme="green"
                    class="md-primary text--color"
                    name="notification_mail"
                    v-model="doctor.notification_mail"
                    >{{
                      translate.pages.profile_doctor.fields.notification_mail
                    }}</md-checkbox
                  >
                </div>
                <div>
                  <md-checkbox
                    id="notification_sms"
                    md-theme="green"
                    class="md-primary text--color"
                    name="notification_sms"
                    v-model="doctor.notification_sms"
                  >
                    {{ translate.pages.profile_doctor.fields.notification_sms }}
                    ({{ doctor.user.sms_used }} /
                    {{ doctor.user.plan.max_sms }})
                  </md-checkbox>
                </div>
                <!-- // OCULTADO POR MAURICIO MARCHANT A PETICIÓN DE SERGIO BUSTAMANTE EL 25 DE SEPT DE 2020
                            <div >
                                <md-checkbox disabled  id="need_box" md-theme="green" class="md-primary" name="need_box" v-model="doctor.need_box">Necesito un BOX</md-checkbox>
                            </div>
                            -->
              </div>
            </div>
            <div class="clearfix"></div>

            <div class="col-md-6">
              <md-input-container
                :class="{
                  'md-input-invalid': errors.hasOwnProperty('password'),
                }"
              >
                <label>{{
                  translate.pages.profile_doctor.fields.password
                }}</label>
                <md-input
                  type="password"
                  v-validate
                  md-no-cache="true"
                  autocomplete="new-password"
                  v-model="doctor.password"
                  data-vv-name="password"
                  data-vv-rules="required|min:6"
                  ref="password"
                  required
                >
                </md-input>
              </md-input-container>
              <span class="md-error"
                >{{
                  errors.hasOwnProperty("password") ? errors.password[0] : ""
                }}
              </span>
            </div>
            <div class="col-md-6">
              <md-input-container
                :class="{
                  'md-input-invalid': errors.hasOwnProperty(
                    'password_confirmation'
                  ),
                }"
              >
                <label>{{
                  translate.pages.profile_doctor.fields.confirm_password
                }}</label>
                <md-input
                  type="password"
                  v-validate
                  v-model="doctor.password_confirmation"
                  data-vv-name="password_confirmation"
                  data-vv-rules="required|min:6|confirmed:password"
                  required
                ></md-input>
                <span
                  class="md-error"
                  v-if="doctor.password != doctor.password_confirmation"
                  >{{
                    errors.hasOwnProperty("password_confirmation")
                      ? errors.password_confirmation[0]
                      : ""
                  }}</span
                >
              </md-input-container>
            </div>

            <!-- <div class="bonus_container medibox" v-if="doctor.need_box" style=" width: 100%; float: left; background: rgba(234, 234, 234, 0.46);">
                            <div class="alert alert-info" style="
                            background: #00bcd4;
                            color: white;
                            padding: 10px;
                            border-radius: 10px;
                        ">MediBox</div>
                            <div style="padding: 10px">
                        <md-layout md-gutter>
                            <div class="alert alert-info" style="
                            background: #8bc34a;
                            color: white;
                            padding: 10px;
                            width:100%;
                            margin-bottom: 20px;
                        ">
                    Busqueda en proceso.
                </div>
    <md-layout md-flex-small="100" md-flex="100">
       <b style="    display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;"> Indique donde prefiere el Box</b>
    </md-layout>
    <md-layout md-flex-small="100" md-flex="100">
        <b>Provincia</b>
    </md-layout>
                        <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px;">
                            {{ box_data.box_region.label }}
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="100">
       <b>Comuna</b>
    </md-layout>
                        <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important; margin-bottom: 27px;">
                            {{ box_data.box_city.label }}
                        </md-layout>

    <md-layout md-flex-small="100" md-flex="100">
       <b style="    display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;"> Indique el periodo de arriendo que desea</b>
    </md-layout>
    <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px;">
                            {{ box_data.box_plan.label.label }}
                        </md-layout>
                        <md-layout md-flex-small="100" md-flex="100">
       <b style="    display: block;border-bottom: 1px solid #c1c0c0; width: 100%; margin-bottom: 25px;"> Indique Especialidad y Horarios</b>
    </md-layout>
                        <md-layout md-flex-small="100" md-flex="100">
        <b>   Especialidad</b>
    </md-layout>
                        <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px;">
                               {{ box_data.box_speciality.label }}
                        </md-layout>
                                                <md-layout md-flex-small="100" md-flex="100">
        <b>   Horario Mañana</b>
    </md-layout>
                        <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px !important;">
                                <ul class="schedule_days">
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.lunes[0]" disabled id="my-test1" name="my-test-group1" md-value="1">Lunes</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.martes[0]" disabled id="my-test1" name="my-test-group1" md-value="1">Martes</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.miercoles[0]" disabled id="my-test1" name="my-test-group1" md-value="1">Miercoles</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.jueves[0]" disabled id="my-test1" name="my-test-group1" md-value="1">Jueves</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.viernes[0]" disabled id="my-test1" name="my-test-group1" md-value="1">Viernes</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.sabado[0]" disabled id="my-test1" name="my-test-group1" md-value="1">Sabado</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.domingo[0]" disabled id="my-test1" name="my-test-group1" md-value="1">Domingo</md-checkbox>
                                    </li>
                                </ul>
                        </md-layout>
                                                                <md-layout md-flex-small="100" md-flex="100">
        <b>   Horario Tarde</b>
    </md-layout>
                        <md-layout md-flex-small="100" md-flex="100" class="container md-input-container masked_input" style="margin-top: 5px !important;margin-bottom: 27px !important;">
                                <ul class="schedule_days">
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.lunes[1]" disabled id="my-test1" name="my-test-group1" md-value="1">Lunes</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.martes[1]" disabled id="my-test1" name="my-test-group1" md-value="1">Martes</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.miercoles[1]" disabled id="my-test1" name="my-test-group1" md-value="1">Miercoles</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.jueves[1]" disabled id="my-test1" name="my-test-group1" md-value="1">Jueves</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.viernes[1]" disabled id="my-test1" name="my-test-group1" md-value="1">Viernes</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.sabado[1]" disabled id="my-test1" name="my-test-group1" md-value="1">Sabado</md-checkbox>
                                    </li>
                                    <li>
                                        <md-checkbox v-model="box_data.box_schedule.domingo[1]" disabled id="my-test1" name="my-test-group1" md-value="1">Domingo</md-checkbox>
                                    </li>
                                </ul>
                        </md-layout>

</md-layout>
    </div>
                                </div> -->

            <div
              class="bonus_container"
              v-if="prefix == 'CL'"
              style="
                background: #eaeaea75;
                width: 100%;
                height: auto;
                float: left;
              "
            >
              <div
                class="alert alert-info"
                style="
                  background: #00bcd4;
                  color: white;
                  padding: 10px;
                  border-radius: 10px;
                "
              >
                Bonificación a Pacientes AMOL
              </div>
              <div style="margin: 10px">
                Ingrese el Descuento que ofrece para cada tipo de Paciente
              </div>
              <div class="bonus_set">
                <label for="bon_particular">Particular</label>
                <small>Porcentaje de descuento</small> <br />
                <!-- <input type="number" name="bon_particular" id="bon_particular" min="0" max="100" v-model="doctor.bon_particular"> -->
                <NumberInputSpinner
                  :min="0"
                  :max="100"
                  :step="1"
                  :inputClass="'spin_input'"
                  :buttonClass="'spin_btn'"
                  :integerOnly="true"
                  v-model="doctor.in_bon_particular"
                />
              </div>
              <div class="bonus_set">
                <label for="bon_fonasa">FONASA</label>
                <small>Porcentaje de descuento de Copago</small> <br />
                <!--<input type="number" name="bon_fonasa" id="bon_fonasa"  min="0" max="100" v-model="doctor.bon_fonasa"> -->
                <NumberInputSpinner
                  :min="0"
                  :max="100"
                  :step="1"
                  :inputClass="'spin_input'"
                  :buttonClass="'spin_btn'"
                  :integerOnly="true"
                  v-model="doctor.in_bon_fonasa"
                />
              </div>
              <div class="bonus_set">
                <label for="bon_isapre">ISAPRE</label>
                <small>Porcentaje de descuento de Copago</small> <br />
                <!--<input type="number" name="bon_isapre" id="bon_isapre"  min="0" max="100" v-model="doctor.bon_isapre"> -->
                <NumberInputSpinner
                  :min="0"
                  :max="100"
                  :step="1"
                  :inputClass="'spin_input'"
                  :buttonClass="'spin_btn'"
                  :integerOnly="true"
                  v-model="doctor.in_bon_isapre"
                />
              </div>
              <div style="width: 100%; margin: 10px; padding: 15px !important">
                <b>Condiciones específicas:</b> Me comprometo a cumplir estos
                descuentos a todos los Pacientes de AMOL por el plazo mínimo de
                un año, y mientras esté vigente mi Registro en AMOL.
              </div>

              <!--<div v-show="(doctor.bon_particular < 25 || doctor.bon_isapre < 25 || doctor.bon_fonasa < 25)" style="clear: both;">
                    <div class="alert alert-info" style="
                    background: rgb(213, 88, 90);
                    color: white;
                    padding: 10px;
                "> Como minimo debes otorgar un 25% de descuento.</div>
                </div> -->
            </div>

            <div class="clearfix"></div>
            <md-button
              v-if="doctor.code != '11111111-1' || doctor.code != '76403501-1'"
              type="submit"
              class="md-raised md-primary md-size margin-t btn--blue"
              :disabled="process"
              >{{ translate.pages.profile_doctor.save_changes_btn }}</md-button
            >
          </div>
        </form>
        <md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialog1">
          <md-dialog-content>{{ alert.msg }}</md-dialog-content>
          <md-dialog-actions>
            <md-button
              class="md-primary"
              @click.native="closeDialog('dialog1')"
              >{{ translate.pages.profile_doctor.close_dialog }}</md-button
            >
          </md-dialog-actions>
        </md-dialog>

        <div class="clearfix"></div>
        <div class="col-md-12 col-xs-12 col-md-12">
          <h1>Sincronizacion con Facebook</h1>
          <div
            class="alert alert-info"
            style="background: rgb(213, 88, 90); color: white; padding: 10px"
          >
            Debido a nuevas políticas de FACEBOOK esta opción se encuentra
            unicamente disponible para Paginas de Facebook que cuentan con mas
            de 2000 seguidores.
          </div>
          <div
            style="
              height: 90px !important;
              background: #e84949;
              color: white;
              padding: 20px;
              border-radius: 5px;
              text-align: justify;
            "
            class="alert alert-danger"
            v-if="FacebookSyncStatus == 4"
          >
            Ocurrio un error en la sincronizacion, recuerde que todos los
            permisos solicitados son necesarios para la integracion
          </div>

          <div
            style="
              height: 110px !important;
              background: #8bc34a;
              color: white;
              padding: 20px;
              border-radius: 5px;
              text-align: justify;
            "
            class="alert alert-success"
            v-if="fbStatus == 3"
          >
            Ya sincronizo Agenda Medica ONLINE con FACEBOOK en su pagina:
            <b>{{ fbPageData.name }}</b
            ><br />
            <md-button @click.native="FacebookRemoveTab()" class="md-raised"
              >Desincronizar</md-button
            >
          </div>
          <fb-signin-button
            v-if="fbStatus != 342432"
            :params="fbSignInParams"
            @success="onSignInSuccess"
            @error="onSignInError"
          >
          </fb-signin-button>
          <div
            class="alert alert-info"
            v-if="fbStatus == 5"
            style="background: #8bc34a; color: white; padding: 10px"
          >
            Sincronización exitosa.
          </div>
          <!--
          <div v-if="fbStatus == 1 || fbStatus == 2" class="fbintegration">
              <h5>Seleccione en que Pagina integrar:</h5>
          <md-list>
                <md-list-item v-for="row in fbPages" :key="row.id" @click="FacebookSelectPage(row)">
                  <span>{{row.name}}</span>
                </md-list-item>
          </md-list>
        </div>
          <md-button v-if="fbStatus == 2" @click.native="FacebookCreateTab()" class="md-raised md-primary md-size margin-t btn--blue">Integrar en: {{fbPageData.name}}</md-button>
          -->
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>

        <div class="clearfix"></div>
        <div class="col-md-12 col-xs-12 col-md-12">
          <h1>Integración en su WEB</h1>
          <div
            class="alert alert-info"
            style="background: #8bc34a; color: white; padding: 10px"
          >
            Con el siguiente código usted o su programador podrá insertar en su
            sitio web el <b>sistema de agendamiento exclusivo</b> de manera
            fácil y rápida.
          </div>
          <div
            class="alert alert-info"
            style="background: #8bc34a; color: white; padding: 10px"
          >
            Si desea añadir mas de un boton en la misma pagina solo debe copiar
            el boton de <b>Agendar Ahora</b> y cambiarle el id="btnModal"
            añadiendole un 1, de la siguiete manera id="btnModal1" asi
            susecivamente hasta llegar a el id="btnModal10".
            <br />
            De ser otra pagina debe copiar el codigo completo.
          </div>
          <div>
            <pre class="code">
                      &lt;button id="btnModal" class="btnStyle"&gt;
                          <br>
                          &nbsp;
                          &nbsp;
                          Agendar Ahora
                      <br>
                          &nbsp;
                          &nbsp;
                          &lt;span class="ir"&gt;
                          &amp;nbsp;
                          &lt;/span&gt;
                      <br>
                      &lt;/button&gt;
                      <br>

                      &lt;div id="tvesModal" class="modalContainer"&gt;
                          <br>
                          &nbsp;&nbsp;&lt;div class="modal-content"&gt;
                          <br>
                          &nbsp;&nbsp;&nbsp;
                          &lt;span class="close"&gt;× &lt;/span&gt;
                          <br>
                          &nbsp;&nbsp;&nbsp;
                          &lt;h2&gt;Modal &lt;/h2&gt;
                          <br>
                          &nbsp;&nbsp;&nbsp;
                          &lt;iframe
                          <br> src="<br>https://globales.<br class="is--movile">agendaenlinea.cl/<br class="is--movile">exclusive/<br class="is--movile">{{doctor.id}}<br>"
                          frameborder="0"<br> style="height:600px;<br> width:100%" &gt;&lt;/iframe&gt;
                          <br>
                          &nbsp;&nbsp;&lt;/div&gt;
                      <br>
                      &lt;/div&gt;
                      <br>
                      &lt;script<br> src="<br>https://amol.cl/iframe/<br class="is--movile">funtionsIframe.js"<br>&gt;&lt;/script&gt;
                      <br>
                      &lt;link<br> rel="stylesheet"<br> href="<br>https://amol.cl/iframe/<br class="is--movile">stylesIframe.css<br>"&gt;
            </pre>
          </div>
        </div>
      </div>
    </md-layout>
    <br />
    <br />
    <br />
  </div>
</template>
<script>
window.lock = false;
var language = window.navigator.userLanguage || window.navigator.language;
import { login, doctor, public_api } from "../../config/api.js";
import NumberInputSpinner from "vue-number-input-spinner";
import vueSelect from "vue-select";
//console.log(language);
//fbSignInParams: {scope: 'manage_pages'},
export default {
  components: {
    vueSelect,
    NumberInputSpinner,
  },
  data() {
    return {
      FacebookSyncStatus: 0,
      box_data: {
        box_schedule: {
          lunes: [null, null],
          martes: [null, null],
          miercoles: [null, null],
          jueves: [null, false],
          viernes: [null, null],
          sabado: [null, null],
          domingo: [null, null],
        },
        box_plan: { label: { label: "-----", value: 0 }, value: "" },
        box_speciality: {
          label: "-----",
          value: "057C453A-17CD-4795-B8F4-5AB95110DFB9",
        },
        box_region: { label: "-----", value: 3871332 },
        box_city: { label: "-----", value: 8261414 },
      },
      filterSpecialities: "",
      appID: "1954146001278287",

      fbSignInParams: {},
      fbLoged: false,
      fbPages: [],
      fbStatus: 0,
      fbPageData: {},
      fbWorking: false,
      fbSynced: false,

      process: false,
      language: "es",
      alert: {
        msg: "",
      },
      prefix: this.$route.params.country.toUpperCase(),
      doctor: {
        code: "",
        name: "",
        lastname: "",
        lastname2: "",
        email: "",
        phone: "",
        password: "",
        password_confirmation: "",
        notification_appointment: false,
        notification_mail: false,
        notification_sms: false,
        type: "doctor",
        specialities: [],
        region: { label: "", value: "" },
        city: { label: "", value: "" },
        bon_particular: 1,
        bon_fonasa: 1,
        bon_isapre: 1,
      },
      specialities: [],
      regions: [],
      cities: [],
      profile_image: "https://api.agendaenlinea.cl/image/default_avatar.png",
      data: {
        listspecialities: [],
        confirmation: {
          isSuccess: false,
          isError: false,
        },
      },
      errors: {
        code: "",
        name: "",
        lastname: "",
        lastname2: "",
        email: "",
        phone: "",
        password: "",
        password_confirmation: "",
        specialities: "",
        formAvatar: "",
      },
      route: {
        doctor: doctor,
      },
    };
  },
  created() {
    self = this;
    /* setTimeout(function(){
                // Login facebook status
                FB.getLoginStatus(function (res) {
                    if(res.status == "connected"){
                        self.fbLoged = true;
                        if(self.fbStatus != 3){
                            self.fbStatus = 1;
                        }
                        self.FacebookGetPages();
                    }
                })
            }, 1000);*/
    // Get Profile
    this.$http
      .get("/doctor/me", {
        headers: {
          Authorization: "Bearer " + this.$auth.getToken(),
        },
      })
      .then((response) => {
        if (response.data.status == "OK") {
          let data = response.data.data;
          self.fbSynced = true;
          if (data.facebook_id && data.facebook_token) {
            self.fbPageData = {
              id: data.facebook_id,
              token: data.facebook_token,
              name: data.facebook_name,
            };
            self.fbStatus = 3;
          }
          data.region = { label: "", value: "" };
          data.city = { label: "", value: "" };
          self.doctor = data;
          console.log("doc", data);
          self.doctor.in_bon_particular = parseInt(data.bon_particular);
          self.doctor.in_bon_fonasa = parseInt(data.bon_fonasa);
          self.doctor.in_bon_isapre = parseInt(data.bon_isapre);
          if (self.doctor.need_box) {
            self.box_data = JSON.parse(self.doctor.box_data);
          }
          if (self.doctor.image) {
            self.profile_image = self.doctor.image;
          } else {
            this.profile_image =
              "https://api.agendaenlinea.cl/image/default_avatar.png";
          }
          if (self.doctor.is_institution) {
            var country = { country: self.$route.params.country.toUpperCase() };
            self.$http
              .post(doctor.api.regions, country, {
                headers: {
                  Authorization: "Bearer " + self.$auth.getToken(),
                },
              })
              .then((response) => {
                let data = response.data.data;
                data.map((item, index) => {
                  item.value = item.geonameId;
                  item.label = item.toponymName;
                  if (item.geonameId == self.doctor.region_id) {
                    self.doctor.region.label = item.toponymName;
                    self.doctor.region.value = item.geonameId;
                    self.$http
                      .post(public_api.api.cities, {
                        region: self.doctor.region.value,
                      })
                      .then((response) => {
                        let data = response.data.data;
                        data.map((_item) => {
                          _item.value = _item.geonameId;
                          _item.label = _item.toponymName;
                          if (_item.toponymName == self.doctor.comunity) {
                            self.doctor.city.label = _item.toponymName;
                            self.doctor.city.value = _item.geonameId;
                          }
                        });
                        self.cities = data;
                      });
                  }
                });
                // storage comunities
                self.regions = data;
              })
              .catch((error) => {
                console.log(error);
                //alert("No se pudo cargar las comunidades");
              });
          }
          self.$http
            .get("/specialities?country=" + self.$route.params.country)
            .then((response) => {
              if (response.data.status == "OK") {
                self.specialities = response.data.data;
                self.doctor.specialities.forEach((speciality) => {
                  self.specialities.find((_speciality) => {
                    if (speciality.id == _speciality.id) {
                      _speciality.checked = true;
                      return false;
                    }
                  });
                });
              }
            });
        }
      });
  },
  computed: {
    filteredSpecialities() {
      let self = this;
      return this.specialities.filter((specialty) => {
        return (
          specialty.name.toLowerCase().indexOf(self.filterSpecialities) >= 0
        );
      });
    },
    // Get Language
    translate() {
      return this.$store.getters.language.app[this.lang].prestador;
    },
    // Get lang
    lang() {
      return this.$store.getters.language.lang;
    },
  },
  methods: {
    // Signin success
    renewPlan() {
      if (window.lock) return;
      window.lock = true;
      this.$http
        .post("https://api.agendaenlinea.cl/api/expresspayment/renew", {
          doctor_id: this.doctor.id,
        })
        .then(function (data) {
          if (data.data.status == 1) {
            var form = document.createElement("form");
            document.body.appendChild(form);
            form.method = "POST";
            form.action = "https://www.flow.cl/app/kpf/pago.php";
            var element1 = document.createElement("INPUT");
            element1.name = "parameters";
            element1.value = data.data.flowpay;
            element1.type = "hidden";
            form.appendChild(element1);
            form.submit();
          }
          window.lock = false;
        });
    },
    anualPlan() {
      if (window.lock) return;
      window.lock = true;
      this.$http
        .post("https://api.agendaenlinea.cl/api/expresspayment/anual", {
          doctor_id: this.doctor.id,
        })
        .then(function (data) {
          if (data.data.status == 1) {
            var form = document.createElement("form");
            document.body.appendChild(form);
            form.method = "POST";
            form.action = "https://www.flow.cl/app/kpf/pago.php";
            var element1 = document.createElement("INPUT");
            element1.name = "parameters";
            element1.value = data.data.flowpay;
            element1.type = "hidden";
            form.appendChild(element1);
            form.submit();
          }
          window.lock = false;
        });
    },
    onSignInSuccess(res) {
      var self = this;
      if (res.status == "connected") {
        //this.fbStatus = 1;
        //this.FacebookGetPages();
        FB.ui(
          {
            method: "pagetab",
            redirect_uri: "https://prestadores.agendaenlinea.cl/cl/profile",
          },
          function (response) {
            console.log(response);
            if (
              response.tabs_added &&
              Object.keys(response.tabs_added).length == 1
            ) {
              self.fbStatus = 5;
            }
          }
        );
      }
    },
    // Facebook getPages
    FacebookGetPages() {
      var self = this;
      FB.api("/me/accounts", function (res) {
        self.fbPages = res.data;
        if (self.fbStatus == 3) {
          var found = false;
          self.fbPages.forEach(function (v, index) {
            if (self.fbPages[index].id == self.fbPageData.id) {
              self.fbPageData.token = self.fbPages[index].access_token;
              found = true;
            }
          });
          if (found) {
            self.updateFacebookData();
          } else {
            self.removeFacebookData();
          }
        }
        console.log(res);
      });
    },
    // Select page from facebook
    FacebookSelectPage(page) {
      if (this.fbWorking) return;
      this.fbPageData = {
        id: page.id,
        token: page.access_token,
        name: page.name,
      };
      this.fbStatus = 2;
      console.log(page);
    },
    // Crete tab to facebook
    FacebookCreateTab() {
      var self = this;
      if (self.fbWorking) return;
      self.fbWorking = true;
      var url = "/" + self.fbPageData.id + "/tabs";
      var data = {
        app_id: self.appID,
        access_token: self.fbPageData.token,
        position: 1,
      };
      FB.api(url, "post", data, function (res) {
        self.fbWorking = false;
        if (res.success && res.success == true) {
          self.fbStatus = 3;
          self.updateFacebookData();
        } else {
          self.fbStatus = 4;
        }
        console.log(res);
      });
    },
    // Remove tab to facebook
    FacebookRemoveTab() {
      var self = this;
      if (self.fbWorking) return;
      self.fbWorking = true;
      var url = "/" + self.fbPageData.id + "/tabs";
      var data = {
        tab: "app_" + self.appID,
        access_token: self.fbPageData.token,
      };
      FB.api(url, "delete", data, function (res) {
        self.fbWorking = false;
        if (res.success && res.success == true) {
          self.fbStatus = 0;
          self.removeFacebookData();
        } else {
          self.fbStatus = 4;
        }
        console.log(res);
      });
    },
    // Update facebook data
    updateFacebookData() {
      this.$http
        .post(doctor.api.facebook, this.fbPageData, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken(),
          },
        })
        .then((response) => {
          let data = response.data.data;
          console.log(data);
        });
    },
    // Remove facebook data
    removeFacebookData() {
      this.$http
        .delete(doctor.api.facebook, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken(),
          },
        })
        .then((response) => {
          let data = response.data.data;
          console.log(data);
        });
    },
    // Sngin error facebook
    onSignInError(error) {
      FB.ui(
        {
          method: "pagetab",
          redirect_uri: "https://prestadores.agendaenlinea.cl/cl/profile",
        },
        function (response) {
          console.log(response);
        }
      );
      console.log("OH NOES", error);
    },
    // Open Modal
    openDialog(ref) {
      this.$refs[ref].open();
    },
    // Close Modal
    closeDialog(ref) {
      this.$refs[ref].close();
      self.alert.msg = "";
    },
    onOpen() {
      console.log("Opened");
    },
    onClose(type) {
      console.log("Closed", type);
    },
    // Send profile doctor
    submit() {
      this.process = true;
      this.doctor.bon_particular = parseInt(this.doctor.in_bon_particular);
      this.doctor.bon_fonasa = parseInt(this.doctor.in_bon_fonasa);
      this.doctor.bon_isapre = parseInt(this.doctor.in_bon_isapre);
      this.$http
        .put("/admin/doctor/" + this.doctor.id, this.doctor, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken(),
          },
        })
        .then((response) => {
          this.process = false;
          if (response.data.status == "OK") {
            self.data.confirmation.isSuccess = true;
            self.data.confirmation.isError = false;
            self.alert.msg = response.data.msg;
          } else {
            self.data.confirmation.isSuccess = false;
            self.data.confirmation.isError = true;
            self.alert.msg = response.data.msg;
          }
          this.openDialog("dialog1");
        })
        .catch((error) => {
          let request_errors = error.response.data;
          for (let error_key in request_errors) {
            this.errors[error_key] = request_errors[error_key];
          }
          //this.errors = this.errors.concat(error.data)
          this.process = false;
          console.log(error);
        });
    },
    // On chose by speciality
    onChosen(add, speciality_id) {
      if (add) {
        this.specialities.find((speciality) => {
          if (speciality.id == speciality_id) {
            speciality.checked = true;
          }
        });
        this.doctor.specialities.push({ id: speciality_id });
      } else {
        this.specialities.find((speciality) => {
          if (speciality.id == speciality_id) {
            speciality.checked = false;
          }
        });
        this.doctor.specialities.find((speciality, index) => {
          if (speciality.id == speciality_id) {
            this.doctor.specialities.splice(index, 1);
            return false;
          }
        });
      }
    },
    // Upload avatar
    uploadAvatarIcon(e) {
      let icon = document.getElementById("fileAvatar");
      icon.click();
    },
    // Change avatar
    onAvatarChange(e) {
      this.errors.formAvatar = "";
      let formAvatar = document.getElementById("formAvatar");
      console.log(formAvatar);
      var weight = formAvatar.fileAvatar.files[0]
        ? formAvatar.fileAvatar.files[0].size / 1024 / 1024
        : 0;
      if (weight >= 1) {
        this.errors.formAvatar = "Imagen pesa demasiado, limite 1MB";
        return;
      }
      let formData = new FormData(formAvatar);
      console.log(formData);
      let url = this.route.doctor.api.upload.avatar;
      let self = this;
      this.process = true;
      this.$http
        .post(url, formData, {
          headers: {
            Authorization: "Bearer " + this.$auth.getToken(),
          },
        })
        .then((response) => {
          this.process = false;
          if (response.data.status == "OK") {
            self.profile_image = response.data.data.image;
          } else {
            self.profile_image =
              "https://api.agendaenlinea.cl/image/default_avatar.png";
          }
          self.data.activeTab = 1;
          self.$store.dispatch("setAvatar", self.profile_image);
        })
        .catch((error) => {
          this.process = false;
          console.log("Catch");
          if (error.response) {
            if ((error.response.status = 422)) {
              // this.setErrors(error.response.data);
            }
          }
        });
    },
    // Change region
    changeRegion(value) {
      if (value) {
        let region = this.regions.find((item) => {
          return item.geonameId == value.geonameId;
        });
        if (region) {
          this.doctor.region_id = region.geonameId;
          this.doctor.region.value = region.geonameId;
          this.doctor.region.label = region.toponymName;
          this.$http
            .post(public_api.api.cities, { region: this.doctor.region.value })
            .then((response) => {
              let data = response.data.data;
              data.map((item) => {
                item.value = item.geonameId;
                item.label = item.toponymName;
              });
              this.cities = data;
              this.doctor.city.label = "";
              this.doctor.city.value = "";
            });
        }
      } else {
        this.cities = [];
      }
    },
    // Change city
    changeCity(value) {
      if (value) {
        if (typeof value != "string") {
          let city = this.cities.find((item) => {
            return item.geonameId == value.geonameId;
          });
          this.doctor.city.label = city.label;
          this.doctor.city.value = city.value;
          this.doctor.comunity = city.label;
        }
      }
    },
  },
};
</script>
<style>
pre {
   border: 1px solid green;
}
@media (min-width: 500px) {
  .is--movile {
    display: none;
    visibility: hidden;
  }
}
.medibox .md-layout.container.md-input-container.masked_input.md-input-invalid {
  padding-bottom: 0 !important;
  margin-bottom: 40px !important;
}

.medibox span.md-error {
  margin-left: 5px !important;
}

.md-error {
  color: red;
  margin-left: 5px !important;
  font-size: 11px;
  margin-top: 5px;
}

ul.schedule_days {
  list-style: none;
  padding: 0;
}

ul.schedule_days label.md-checkbox-label {
  position: initial;
}
ul.schedule_days li {
  display: inline-block;
  min-width: 110px;
  padding: 10px;
  background: #d2e6e8;
  overflow: hidden;
}
ul.schedule_days li:nth-child(odd) {
  background: #dbe0e0;
}

.bonus_container {
  margin-top: 20px;
}
.bonus_set {
  width: 33.33%;
  text-align: center;
  font-size: 20px;
  padding: 20px;
  float: left;
}
.bonus_set input {
  width: 100%;
  height: 30px;
  text-align: center;
}
.marcaagua {
  font-size: 10px;
  color: gray;
}

.bonus_set small {
  font-size: 10px;
  display: block;
}
.bonus_set:nth-child(3) {
  background-color: #f0efef;
}
.bonus_set:nth-child(4) {
  background-color: #e5e3e3b5;
}

@media (max-width: 760px) {
  .bonus_set {
    width: 100%;
    float: none !important;
    clear: both !important;
  }
  .bonus_container {
    height: auto !important;
    margin-top: 20px;
  }
}
input.spin_input {
  -webkit-appearance: none;
  border: 1px solid #ebebeb;
  float: left;
  font-size: 16px;
  height: 40px !important;
  margin: 0;
  outline: none;
  text-align: center;
  width: calc(100% - 80px) !important;
}

button.spin_btn {
  -webkit-appearance: none;
  transition: background 0.5s ease;
  background: #387e90;
  border: 0;
  color: #fff;
  cursor: pointer;
  float: left;
  font-size: 20px;
  height: 40px;
  margin: 0;
  outline: none;
  width: 40px !important;
}
</style>
<style>
.text--color {
  color: black !important;
}
.fb-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 8px 8px;
  border-radius: 3px;
  background-color: #4267b2;
  background: url("../../assets/img/facebook.png");
  color: #fff;
  cursor: pointer;
  width: 270px;
  height: 50px;
}
.fbintegration li.md-list-item {
  border: 0.5px solid #d2c9c9;
}
pre.code {
  background: whitesmoke;
  white-space: normal;
  padding: 20px;
}
</style>
<style lang="stylus" scoped>
@import '../../assets/styles/variables/color.styl';
@import '../../assets/styles/boots.styl';
@import '../../assets/styles/common.styl';

.multiple {
  border: 1px solid color_form_border;
  border-radius: 5px;
  width: 100%;

  .title {
    margin: 0.5em;
    color: color_form_placeholder;
  }

  .select {
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 0.25em;
    height: 110px;

    .option {
      width: 95%;
      margin: 0.25em;
    }
  }
}

.subtitle {
  margin-top: 0.5em;
  color: color_form_placeholder;
}

.mar-top-1 {
  margin-top: 1em;
}

.mar-top-2 {
  margin-top: 2em;
}

.row {
  margin: 0;
  padding: 0.5em;
}

@import '../../assets/styles/responsive.styl';
</style>



// WEBPACK FOOTER //
// ProfileDoctor.vue?f53baadc